module.exports = __webpack_public_path__ + "img/xcx.2cab11e4.jpg";